export class ApplicationFeeEscalationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeeEscalations({ loanId, status }) {
    return this.#http.get(`/loans/${loanId}/fee-escalations`, {
      loanId,
      status,
    });
  }
}
